import React, { Component, PropTypes, cloneElement } from 'react';
import { Snackbar } from 'material-ui';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { onUserInput } from '../../stores/userInputActions';
import { openDialog, closeDialog } from '../../stores/dialogActions';
import actions from '../../stores/contracting/root-actions-map';
import { getTemplates } from '../../stores/contracting/template-list/template-list-actions';
import { getContractingYears } from '../../stores/actions';
import ContractListIcon from 'material-ui/svg-icons/action/chrome-reader-mode';
import DashboardIcon from 'material-ui/svg-icons/action/dashboard';
import ReportsIcon from 'material-ui/svg-icons/action/assessment';
import TemplateIcon from 'material-ui/svg-icons/action/description';
import RequestsWithSameNameOrDomainDialog from './requestsWithSameNameOrDomain';
import RequestDLDialog from './contract-activities-products/contract-container/dialogs/request-data-loading';
import FlatButton from '../tc-ui/flat-button-with-loader';
import YearDropDown from './yearDropdown';
import moment from 'moment';
import WallWrapper from '../wall/wrapper';

const convertToYY = ({ startDate, endDate }) => startDate && endDate ? `${moment.utc(startDate).format('D MMM YYYY')} - ${moment.utc(endDate).format('D MMM YYYY')}` : '';
class ContractingController extends Component {

  constructor(props) {
    super(props);

    this.goTo = this.goTo.bind(this);
  }

  componentWillMount() {
    const { dispatch, user } = this.props;
    dispatch(getContractingYears());
    if (
      user.user.type === 'Supplier'
      && window.location.pathname.indexOf('template-list') === -1
      && user.user.email.indexOf('dl+') === -1
      ) {
      dispatch(getTemplates());
    }
  }

  goStartNewContract = () => {
    window.location = `${process.env.NEW_SYSTEM_URL}/partner-management/send-assets?jwt=${
      localStorage.getItem('jwt')
    }&open_asset_type=${this.props.user.user.type === 'Contractor' ? 'requests' : 'rates'}`
  };

  goTo = (path) => {
    const { history } = this.props;
    history.push(path);
  }

  render() {
    const {
      children,
      user,
      location: { pathname, query: { latest }},
      contractId,
      contractPeriods,
      contractListSearchParams,
      templateListSearchParams,
      contractListType,
      updateCurrentYear,
      billingPlan,
      templateList,
      contractVersions,
      push,
      ...props
    } = this.props;
    const extraProps = {
      downloadExistingConnections: this.downloadExistingConnections,
      goStartNewContract: this.goStartNewContract,
      user,
      ...props,
    };
    const showBannerRoutes = [
      '/contracting/contract-list',
      '/contracting/template-list',
      '/contracting/supplier-updates-queue',
      '/contracting/master-template-list',
      '/contracting/supplier-dashboard',
      '/contracting/buyer-dashboard',
      '/contracting/reports',
    ];
    if (Boolean(latest) && contractVersions.length > 0) {
      const latestId = contractVersions[contractVersions.length - 1];
      if (latestId !== contractId) {
        push(pathname.replace(contractId, latestId));
      } else {
        push(pathname);
      }
    }
    return (
      <div className="l-app-content" style={{ paddingTop: '70px', maxWidth: '1440px', ...Boolean(latest) ? { display: 'none' } : {} }}>
        {
          showBannerRoutes.some(route => pathname.indexOf(route) > -1) && (
            <div className="flex-tc-sb" style={{ flexDirection: 'row-reverse', backgroundColor: '#00bcd4', height: '48px', lineHeight: '48px', color: 'white', fontSize: '18px', padding: '4px' }}>
              <div className="flex-tc-sb">
                {
                  user.user.type === 'Supplier' ? (
                    <FlatButton
                      icon={<TemplateIcon style={{ fill: 'white' }} />}
                      label="Rate Templates"
                      labelStyle={{ color: 'white', textTransform: 'none', fontSize: '18px' }}
                      style={{ height: '40px' }}
                      hoverColor="rgba(0, 0, 0, 0.1)"
                      backgroundColor={pathname.indexOf('template-list') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
                      disabled={pathname.indexOf('template-list') > -1}
                      onTouchTap={() => this.props.push({
                        pathname: `/contracting/template-list`,
                        query: templateListSearchParams,
                      })}
                    />
                  ) : (
                    <FlatButton
                      icon={<TemplateIcon style={{ fill: 'white' }} />}
                      label="Workspace List"
                      labelStyle={{ color: 'white', textTransform: 'none', fontSize: '18px' }}
                      style={{ height: '40px' }}
                      hoverColor="rgba(0, 0, 0, 0.1)"
                      onClick={() => window.location = `${process.env.NEW_SYSTEM_URL}/contracting/workspace-list?jwt=${localStorage.getItem('jwt')}`}
                    />
                  )
                }
                <FlatButton
                  icon={<ContractListIcon style={{ fill: 'white' }} />}
                  label="Contract List"
                  labelStyle={{ color: 'white', textTransform: 'none', fontSize: '18px' }}
                  style={{ height: '40px' }}
                  hoverColor="rgba(0, 0, 0, 0.1)"
                  backgroundColor={pathname.indexOf('contract-list') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
                  disabled={pathname.indexOf('contract-list') > -1}
                  onClick={() => {
                    if (user.user.type === 'Contractor') {
                      window.location = `${process.env.NEW_SYSTEM_URL}/contracting/contract-list?jwt=${localStorage.getItem('jwt')}`;
                    } else {
                      this.props.push({
                        pathname: `/contracting/contract-list/${contractListType || 'recent'}`,
                        query: contractListSearchParams,
                      });
                    }
                  }}
                />
                <FlatButton
                  icon={<DashboardIcon style={{ fill: 'white' }} />}
                  label="Dashboard"
                  labelStyle={{ color: 'white', textTransform: 'none', fontSize: '18px' }}
                  style={{ height: '40px' }}
                  hoverColor="rgba(0, 0, 0, 0.1)"
                  backgroundColor={pathname.indexOf('-dashboard') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
                  disabled={pathname.indexOf('-dashboard') > -1}
                  onTouchTap={() => this.props.push(`/contracting/${user.user.type === 'Supplier' ? 'supplier' : 'buyer'}-dashboard`)}
                />
                <WallWrapper lockIcon amazonOrange>
                  <FlatButton
                    icon={<ReportsIcon style={{ fill: 'white' }} />}
                    label="Reports"
                    labelStyle={{ color: 'white', textTransform: 'none', fontSize: '18px' }}
                    style={{ height: '40px' }}
                    hoverColor="rgba(0, 0, 0, 0.1)"
                    backgroundColor={pathname.indexOf('/contracting/reports') > -1 ? 'rgba(0, 0, 0, 0.2)' : null}
                    disabled={pathname.indexOf('/contracting/reports') > -1}
                    onTouchTap={() => this.props.push('/contracting/reports')}
                  />
                </WallWrapper>
              </div>
              <div className="flex-tc-sb" style={{ display: 'flex' }}>
                <YearDropDown
                  showAllPeriods={pathname.indexOf('contract-list') > -1 || pathname.indexOf('template-list') > -1}
                  selectAllPeriods={pathname.indexOf('contract-list') > -1 ? props.selectAllPeriodsForContractList : props.selectAllPeriodsForTemplateList}
                  arrayOfYears={contractPeriods}
                  selectedYearRange={(pathname.indexOf('contract-list') > -1 && contractListSearchParams.searchingAllYears) || (pathname.indexOf('template-list') > -1 && templateList.searchingAllYears)
                    ? 'All Periods' : convertToYY(this.props.currentYear)}
                  currentPeriod={this.props.currentYear}
                  onDropdownChange={updateCurrentYear(pathname)}
                />
                {
                  Boolean(contractListType === 'search' && pathname.indexOf('contract-list') > -1)
                  && <span style={{ fontSize: '14px', position: 'relative', top: '4px' }}>&nbsp;Search Results - {contractListSearchParams.searchCategory}</span>
                }
              </div>
            </div>
          )
        }
        {children ? cloneElement(children, extraProps) : undefined}
        <Snackbar
          bodyStyle={{ maxWidth: '768px' }}
          action="Dismiss"
          onActionTouchTap={this.props.clearContractingErrorString}
          onRequestClose={this.props.clearContractingErrorString}
          autoHideDuration={6000}
          open={Boolean(this.props.contractingErrorString)}
          message={this.props.contractingErrorString}
        />
        {
          user.user.type === 'Contractor' && (
            <RequestsWithSameNameOrDomainDialog/>
          )
        }
        {
          user.user.type === 'Contractor' && (
            <RequestDLDialog/>
          )
        }
      </div>
    );
  }
}

ContractingController.propTypes = {
  dispatch: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  user: PropTypes.object,
  children: PropTypes.object,
  params: PropTypes.object,
  clearContractingErrorString: PropTypes.func,
  contractingErrorString: PropTypes.string,
  push: PropTypes.func,
  currentYear: PropTypes.object,
  contractPeriods: PropTypes.array,
  updateCurrentYear: PropTypes.func,
  contractListType: PropTypes.string,
  contractListSearchParams: PropTypes.object,
  templateListSearchParams: PropTypes.object.isRequired,
  billingPlan: PropTypes.string,
  selectAllPeriodsForContractList: PropTypes.func,
  selectAllPeriodsForTemplateList: PropTypes.func,
};

const mapStateToProps = ({ contracting, user, ui }, { location: { query: { latest }}}) => {
  const contractVersions = (() => {
    if (!latest) return [];
    const versions = contracting.contractActivitiesProducts.getIn(['leftNav', 'allVersions']);
    return (versions && versions !== 'versions') ? versions.toJS() : [];
  })();
  return {
    wizard: contracting.wizard.toJS(),
    contractingErrorString: contracting.contractingError.get('errorString'),
    templateList: contracting.templateList.toJS(),
    isShellAccount: user.get('contractingShell') || false,
    isTourReady: ui.walkthru.get('isTourReady'),
    isTourRunning: ui.walkthru.get('isOpen'),
    contractListType: contracting.contractList.getIn(['list', 'listType']),
    contractListSearchParams: contracting.contractList.get('searchParams').toJS(),
    templateListSearchParams: {
      statusesFilter: contracting.templateList.get('statusesFilter').toJS(),
      showType: contracting.templateList.get('showType'),
    },
    contractPeriods: contracting.contractPeriods,
    currentYear: contracting.currentYear,
    billingPlan: user.get('billingPlan'),
    contractId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    contractVersions,
  };
};

const mapDispatchToProps = dispatch => ({
  onUserInput: onUserInput(dispatch, actions),
  openDialog: openDialog(dispatch, actions),
  closeDialog: closeDialog(dispatch, actions),
  clearContractingErrorString: onUserInput(dispatch, actions, 'clearContractingErrorString'),
  push: (...args) => dispatch(pushAction(...args)),
  updateCurrentYear: currentRoute => (dates) => dispatch({ type: '[contracting]SELECTED_YEAR_FOR_CONTRACTING', payload: dates, currentRoute }),
  selectAllPeriodsForContractList: () => dispatch({ type: '[contract-list]UPDATE_SEARCH_PARAMS', payload: { searchingAllYears: true } }),
  selectAllPeriodsForTemplateList: () => dispatch({ type: '[template-list]UPDATE_PROPS_IN_TEMPLATE_LIST', payload: { searchingAllYears: true } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractingController);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contracting-container.jsx